import React from 'react';
import TryhardPageFrame from '../TryhardPageFrame';
import TryhardH2 from '../../TryhardMarkups';
import { Link, Outlet, useLocation } from 'react-router';
import { animate, AnimatePresence, motion, useMotionValue } from 'motion/react';
import { BounceTransitionWrap } from '../../../../../../utils/transitions';

interface MenuItemProps {
    children: any,
    highlight: boolean
}

const MenuItem: React.FC<MenuItemProps> = ({ highlight, children }) => {
    const x = useMotionValue(0);

    const handleOnPointerOver = () => { animate(x, 8) }

    const handleOnPointerOut = () => { animate(x, 0) }

    return (
        <motion.li
            style={{ x }}
            className={'w-full hover:cursor-pointer ' + (highlight ? 'font-semibold' : '')}
            onPointerOver={handleOnPointerOver}
            onPointerOut={handleOnPointerOut}
        >
            {children}
        </motion.li>
    )
}

const ProductsMenu: React.FC = () => {
    const pathnames = useLocation().pathname.split('/');
    const end = pathnames[pathnames.length - 1]

    return (
        <motion.ul className='px-4 py-2 gap-y-2 text-lg text-gray-900 bg-white bg-opacity-30 shadow-xl rounded-b-lg sm:rounded-br-lg flex flex-col items-center sm:items-end top-0 left-0 sm:absolute'>
            <Link to=''>
                <MenuItem highlight={(end === 'products')}>Boards</MenuItem>
            </Link>
            <Link to='boxes'>
                <MenuItem highlight={(end === 'boxes')}>Deck Boxes</MenuItem>
            </Link>
        </motion.ul>
    )
}

const TryhardProducts: React.FC = () => {
    return (
        <TryhardPageFrame key='products'>
            <motion.div className='flex flex-col items-center gap-y-8 text-xl text-gray-700'>


                <div className='flex flex-col items-center gap-y-2'>
                    <AnimatePresence>
                        <BounceTransitionWrap key={1}>
                            <TryhardH2>Products</TryhardH2>
                        </BounceTransitionWrap>
                        <BounceTransitionWrap key={2} delay={.05}>
                            <p className='max-w-96 text-center bg-white bg-opacity-30 px-4 py-2 shadow-lg rounded-lg'>The Tryhard catalogue ranges from tablets to brushes to dice and sleeve protectors, with more on the way!</p>
                        </BounceTransitionWrap>
                    </AnimatePresence>
                </div>

                <ProductsMenu />

                <AnimatePresence mode='wait'>
                    <Outlet />
                </AnimatePresence>
            </motion.div>



        </TryhardPageFrame>
    )
}

export default TryhardProducts;